module.exports = __webpack_public_path__ + "static/img/jingdong.309cb2c3.png";